// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"cfa0b459","426":"cfa0b459","642":"cfa0b459"}[chunkId] + ".chunk.css";
};